
const common = {
  // Navigation
  brand_story: "ブランドストーリー",
  our_philosophy: "私たちの哲学", 
  product_series: "製品シリーズ",
  global_sourcing: "グローバル調達",
  start_journey: "旅を始める",
  
  // Hero Section
  hero_title: "若さの",
  hero_title_highlight: "権利を取り戻す",
  hero_description: "LunaKeyは自然界で最も効果的なスーパーフードを提供し、科学的に作られ、あなたの日常の儀式に組み込まれ、輝きと永遠の活力を放つことができます。",
  hero_cta: "あなたの旅を始める",
  
  // Story Section
  story_title: "神話から現代へ",
  story_subtitle: "伝説から現実へ",
  story_description_1: "古い伝説では、ルナ女神が月光の下で霊鹿と踊り、自然の秘密と生命の活力を守っていました。この神話的な力は、現代科学の精密な抽出により、あなたの手にあるすべてのLunaKey製品に変わりました。",
  story_description_2: "私たちは「自然が力を与え、科学が権利を確認する」という理念を堅持し、世界で最も貴重なスーパーフードを厳格な科学的プロセスを通じて、あなたの日常生活の活力源に変えています。",
  story_quote: "私たちは時間と戦うのではなく、時間の中で若さを感じるあなたの権利を再構築します。",
  
  // Philosophy Section
  philosophy_title: "私たちの哲学",
  philosophy_subtitle: "三位一体の価値体系で、あなたの健康的なライフスタイルを構築",
  natures_proof: "自然の証明",
  natures_proof_subtitle: "自然の証明",
  natures_proof_description: "世界中から調達された高効率スーパーフード、人工添加物ゼロ。すべての製品は自然の最も純粋な力を担い、厳格な選別と科学的検証を経ています。",
  empowered_confidence: "力を与えられた自信",
  empowered_confidence_subtitle: "力を与えられた自信",
  empowered_confidence_description: "自分の健康をコントロールすることから生まれる落ち着きと安心感を感じてください。LunaKeyを選ぶとき、あなたは自分への最高の投資とケアを選んでいます。",
  your_vitality: "あなたの活力、あなたの権利",
  your_vitality_subtitle: "あなたの活力、あなたの権利",
  your_vitality_description: "積極的な自己ケアと健康主権に関する宣言。あなたには最高の状態を持つ権利があり、生命の無限の活力を感じる権利があります。",
  
  // Products Section
  products_title: "あなたの権利、ここで再構築",
  products_subtitle: "2つの主要製品シリーズで、あなたの健康と美しさを包括的にサポート",
  proof_series: "権利証明シリーズ",
  proof_series_subtitle: "権利証明シリーズ",
  proof_series_description: "世界のトップクラスのスーパーフードを厳選し、あなたの健康に最も強力な証明を提供します。すべての製品は厳格な品質管理を経て、最も純粋な栄養補給を確保します。",
  declaration_series: "エネルギー宣言シリーズ",
  declaration_series_subtitle: "エネルギー宣言シリーズ",
  declaration_series_description: "現代のライフスタイルのために設計されたエネルギー補給ソリューションで、忙しい日常でも最高の状態を維持し、内なる輝きと活力を示すことができます。",
  acai_powder: "アサイーパウダー",
  acai_description: "抗酸化物質が豊富、免疫力向上",
  white_tomato: "ホワイトトマトパウダー",
  white_tomato_description: "天然美白、肌の輝きを放つ",
  glow_booster: "グロウブースター",
  glow_description: "内外兼修、自然な輝きを咲かせる",
  energy_elixir: "エナジーエリクサー",
  energy_description: "持続的エネルギー、無限の可能性を引き出す",
  learn_more: "詳しく見る",
  
  // Sourcing Section
  sourcing_title: "鹿の足跡を辿って",
  sourcing_subtitle: "霊鹿の足跡を辿り、世界で最も貴重なスーパーフードの原産地を探索",
  brazil: "ブラジル",
  brazil_ingredient: "アサイーベリー",
  brazil_description: "アマゾン熱帯雨林の奥深くからの紫の宝石、アントシアニンと抗酸化物質が豊富で、自然が与えた若さの暗号です。",
  peru: "ペルー",
  peru_ingredient: "マカ根",
  peru_description: "アンデス山脈高原のエネルギー源、千年来「ペルー人参」として称賛され、体に持続的な活力を注入します。",
  himalaya: "ヒマラヤ",
  himalaya_ingredient: "クコの実",
  himalaya_description: "世界の屋根の赤い宝石、極地環境で育まれた超強生命力、心身を滋養する天然良薬。",
  mediterranean: "地中海",
  mediterranean_ingredient: "オリーブ葉",
  mediterranean_description: "地中海の太陽の下の緑のエッセンス、千年の健康の知恵を担い、現代生活に純粋な守護をもたらします。",
  
  // Newsletter Section
  newsletter_title: "活力リニューアルガイドを受け取る",
  newsletter_description: "私たちの専用コンテンツを購読して、最新の健康情報、製品アップデート、専門的な栄養アドバイスを取得し、あなたの活力の旅を始めましょう。",
  email_placeholder: "あなたのメールアドレス",
  subscribe: "購読",
  subscribing: "購読中...",
  subscribe_success: "購読成功！LunaKeyファミリーに参加していただき、ありがとうございます。",
  subscribe_error: "購読に失敗しました。後でもう一度お試しください。",
  privacy_notice: "私たちはあなたのプライバシーを保護することを約束し、第三者とあなたの情報を共有しません。いつでも購読を解除できます。",
  
  // Footer
  quality_assurance: "品質保証",
  about_us: "私たちについて",
  contact_us: "お問い合わせ",
  careers: "採用情報",
  faq: "よくある質問",
  user_guide: "使用ガイド",
  customer_service: "カスタマーサービス", 
  return_policy: "返品ポリシー",
  footer_description: "若さの権利を取り戻し、自然の最も効果的なスーパーフードをあなたの日常の儀式に組み込み、輝きと永遠の活力を放ちます。",
  all_rights_reserved: "すべての権利を保有",
  privacy_policy: "プライバシーポリシー",
  terms_of_service: "利用規約"
};

export default common;
